/** İşe giriş / işten çıkış görevleri ve zimmet metinleri. */
export const lifecycle = {
  kind: {
    onboarding: "İşe giriş",
    offboarding: "İşten çıkış",
  },
  assigneeKind: {
    hr: "İK",
    manager: "Yönetici",
    employee: "Çalışanın kendisi",
    it: "BT / sistem yöneticisi",
    finance: "Finans",
    specific: "Belirli bir kişi",
  },
  pool: {
    hr: "İK ekibi",
    manager_missing: "İK ekibi (yönetici atanmamış)",
    it: "BT / sistem yöneticisi",
    finance: "Finans ekibi",
  },
  category: {
    access: "Erişim",
    equipment: "Ekipman",
    document: "Belge",
    payroll: "Bordro",
    orientation: "Oryantasyon",
    other: "Diğer",
  },
  taskStatus: {
    open: "Açık",
    done: "Tamamlandı",
    skipped: "Atlandı",
  },
  checklistStatus: {
    open: "Devam ediyor",
    completed: "Tamamlandı",
    cancelled: "İptal edildi",
  },
  task: {
    returnAsset: "Zimmet iadesini al: {asset}",
    returnAssetDescription: "{tag} etiketli demirbaşı teslim alın ve iadesini kaydedin. Kayıt yapılınca bu görev kendiliğinden tamamlanır.",
    closeAccess: "Sistem ve e-posta erişimlerini kapat",
    closeAccessDescription: "Son çalışma gününün sonunda tüm hesapları ve kartları kapatın.",
  },
  auto: {
    documentAccepted: "Belge kabul edilince kendiliğinden tamamlandı.",
    assetReturned: "Zimmet iadesi kaydedilince kendiliğinden tamamlandı.",
  },
  notify: {
    manyTasks: "{first} ve {count} görev daha",
    noDue: "belirtilmedi",
  },
  reason: {
    resignation: "İstifa",
    employer_termination: "İşveren feshi",
    mutual_agreement: "Karşılıklı anlaşma (ikale)",
    retirement: "Emeklilik",
    contract_end: "Belirli süreli sözleşmenin bitişi",
    other: "Diğer",
  },
  asset: {
    category: {
      computer: "Bilgisayar",
      phone: "Telefon",
      tablet: "Tablet",
      monitor: "Monitör",
      peripheral: "Çevre birimi",
      access_card: "Giriş kartı",
      vehicle: "Araç",
      furniture: "Mobilya",
      other: "Diğer",
    },
    status: {
      in_stock: "Depoda",
      assigned: "Zimmetli",
      retired: "Kullanım dışı",
      lost: "Kayıp",
    },
    condition: {
      good: "Sağlam",
      damaged: "Hasarlı",
      lost: "Kayıp / teslim edilmedi",
    },
  },
  errors: {
    checklist_exists: "Bu çalışan için açık bir {kind} listesi zaten var. Mevcut listeyi kullanın ya da önce iptal edin.",
    use_offboarding: "İşten çıkış listesi, çalışan sayfasından işten çıkış süreci başlatılarak oluşturulur.",
    employee_terminated: "Bu çalışanın ayrılışı tamamlanmış; yeni görev listesi başlatılamaz.",
    template_kind_mismatch: "Seçilen şablon bu süreç türüne ait değil. Doğru türde bir şablon seçin.",
    task_closed_list: "Bu görevin listesi kapatılmış. Gerekirse İK ekibinden yeni liste başlatmasını isteyin.",
    task_not_open: "Bu görev zaten kapatılmış. Değiştirmek için önce yeniden açın.",
    task_already_open: "Bu görev zaten açık.",
    record_asset_return: "Bu görev zimmet iadesi kaydedilince kendiliğinden tamamlanır. Zimmet ekranından iadeyi kaydedin.",
    asset_already_returned: "Bu zimmetin iadesi kaydedilmiş; görev yeniden açılamaz.",
    asset_already_assigned: "Bu demirbaş şu anda {name} kişisinde. Önce iadesini kaydedin.",
    asset_not_available: "Bu demirbaş “{status}” durumunda olduğu için zimmetlenemez. Önce durumunu “Depoda” yapın.",
    asset_assigned: "Demirbaş zimmetliyken bu işlem yapılamaz. Önce iadesini kaydedin.",
    asset_return_before_assign: "İade tarihi zimmet tarihinden ({date}) önce olamaz.",
    already_offboarding: "Bu çalışan için işten çıkış süreci zaten başlatılmış.",
    not_offboarding: "Bu çalışan için başlatılmış bir işten çıkış süreci yok.",
    last_day_before_start: "Son çalışma günü işe başlama tarihinden ({date}) önce olamaz.",
    before_last_working_day: "Son çalışma günü ({date}) gelmeden kapanış yapılamaz. O gün ya da sonrasında tekrar deneyin.",
    offboarding_incomplete: "Kapanış için önce açık görevleri tamamlayın ya da atlayın ve zimmet iadelerini kaydedin: {tasks} açık görev, {assets} iade edilmemiş zimmet.",
    no_balance: "Ücrete dönüştürülecek izin bakiyesi yok.",
    payout_exceeds_balance: "En fazla kalan bakiye ({balance}) kadar ücrete dönüştürülebilir.",
    no_annual_type: "Yıllık izin türü bulunamadı. İzin türünü seçerek tekrar deneyin.",
    self_complete: "Kendi işten çıkışınızı kapatamazsınız; kapanışı başka bir İK yetkilisi yapmalı.",
    last_admin: "Ayrılan kişi şirketin son sistem yöneticisi. Önce başka birine sistem yöneticisi rolü verin.",
    open_tasks: "{count} açık görev var; tamamlayın ya da atlayın.",
    unreturned_assets: "{count} zimmetin iadesi kaydedilmedi.",
  },
  payoutNote: "İşten çıkışta kullanılmayan izin ücrete dönüştürüldü",
};
